import { render } from "./markedList.vue?vue&type=template&id=61fbc4f0&scoped=true"
import script from "./markedList.vue?vue&type=script&lang=js"
export * from "./markedList.vue?vue&type=script&lang=js"

import "./markedList.vue?vue&type=style&index=0&id=61fbc4f0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fbc4f0"]])

export default __exports__